// Whether the live badge may follow the phone's tilt (deviceorientation). Android and most browsers just send it; iPhone
// asks first (DeviceOrientationEvent.requestPermission, from a tap) — the big view offers "Tilt with your phone" then.
import { create } from "zustand";

type Req = { requestPermission?: () => Promise<"granted" | "denied"> };
const needsAsk = (): boolean => typeof DeviceOrientationEvent !== "undefined" && typeof (DeviceOrientationEvent as unknown as Req).requestPermission === "function";
const hasSensor = (): boolean => typeof window !== "undefined" && "DeviceOrientationEvent" in window;

interface Motion {
  on: boolean;
  /** iPhone: not asked yet (the button shows) */
  askable: boolean;
  ask: () => Promise<void>;
}

export const useMotion = create<Motion>((set) => ({
  on: hasSensor() && !needsAsk(),
  askable: hasSensor() && needsAsk(),
  ask: async () => {
    try {
      const r = await (DeviceOrientationEvent as unknown as Req).requestPermission!();
      set({ on: r === "granted", askable: false });
    } catch {
      set({ askable: false });
    }
  },
}));
